"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.knowledge.exceeded': 'Limite voci di conoscenza raggiunto. Aggiorna il tuo piano per aggiungere più voci.',
    'limits.knowledge.limitReached': 'Limite conoscenza: {limit} (aggiorna per aggiungerne di più)',
};
